import { Box, Typography, Button} from '@mui/material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getImageUrl } from '../../utils';
import { Link } from 'react-router-dom';

const images = [
  { src: getImageUrl('hero-19.png'), alt: 'Pilates 8' },

  
];

const Hero = () => {
  const background = getImageUrl('hero-19.png'); 

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: { xs: '70vh', md: '80vh' },
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        
        color: '#fff',
        zIndex: 1,
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 2,
        }}
      />
      {/* Content */}
      <Box sx={{ position: 'relative', zIndex: 3, maxWidth: '800px' }}>
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'var(--font-heading)',
            fontSize: { xs: '2rem', md: '3rem' },
            fontWeight: 700,
            letterSpacing: '0.05em',
            mb: 2,
            textShadow: '2px 4px 10px rgba(0,0,0,0.8)',
          }}
        >
          Pilates Höganäs
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '1rem', md: '1.25rem' },
            fontFamily: 'var(--font-body)',
            mb: 4,
            color: '#f0f0f0',
          }}
        >
          Träna i en inspirerande miljö med kunniga instruktörer.
        </Typography>
        <Button
          component={Link}
          to="/sidepages/schema"
          sx={{
            background: 'linear-gradient(135deg, #00b5bf, #429398)',
            color: '#fff',
            px: 4,
            py: 1.5,
            borderRadius: '999px',
            fontWeight: 600,
            fontSize: '1rem',
            boxShadow: '0px 6px 18px rgba(0,0,0,0.2)',
            textTransform: 'none',
            transition: 'all 0.3s ease',
            '&:hover': {
                      transform: 'translateY(-2px)',
                      background: 'linear-gradient(135deg, #007C85, #357f87)',
                    },
          }}
        >
          Se schema
        </Button>
      </Box>
    </Box>
  );
};

export default Hero;